import { Inject, Injectable, Injector } from '@angular/core';
import { BehaviorSubject, tap } from 'rxjs';
import {
  ChangeLoginRequest,
  LoginRequest,
  LoginResponse,
  PaginatorResponse,
  UserRequest,
  UserResponse,
} from '../../../models/login.models';
import { JwtTokenService, UtilsBaseApiService } from '@brunsker/libs/core/utils/base-api';
import { ENVIRONMENT_TOKEN, Environment } from '@brunsker/libs/core/utils/http-log-interceptor/src';
import { CookiesService } from '@brunsker/libs/core/utils/cookies/src';
import { SelectClientService } from '@brunsker/libs/portal-do-vendedor/utils/portal-vendedor-api';

@Injectable({
  providedIn: 'root',
})
export class NewApiUserService extends UtilsBaseApiService<NewApiUserService> {
  user!: LoginResponse | null;
  currentUser$$ = new BehaviorSubject<LoginResponse | null>(null);
  currentUser$ = this.currentUser$$.asObservable();
  readonly LOGIN_EXTENSION = 'login';
  readonly CHANGE_LOGIN = 'mudancaLogin';
  readonly GET_PRODUCTS_EXTENSION = 'getProdutos';

  constructor(
    @Inject(ENVIRONMENT_TOKEN) readonly environment: Environment,
    override readonly injector: Injector,
    private cookies: CookiesService,
    private tokenInject: JwtTokenService,
    private selectClientService: SelectClientService
  ) {
    super('usuario', injector, environment.BASE_API_URL);

    const hasUser = sessionStorage.getItem('user');

    if (hasUser) {
      this.user = JSON.parse(hasUser);
      this.currentUser$$.next(this.user);
      this.tokenInject.setJwtToken(this.user?.token ?? '');
    }
  }

  currentUser() {
    return this.currentUser$$.value;
  }

  createUser = (user: UserRequest) =>
    this.create<UserRequest, UserResponse>(user);

  updateUser = (user: UserRequest) => this.update<UserResponse>(user);

  deleteUser = (seq_cliente: number) => this.delete<boolean>(seq_cliente);

  login(loginRequest: LoginRequest) {
    return this.httpClient
      .post<LoginResponse[]>(
        `${this.BASE_URL}${this.CONTEXT}/${this.LOGIN_EXTENSION}`,
        loginRequest
      )
      .pipe(
        tap(([user]) => {
          this.tokenInject.setJwtToken(user.token);
          const userStringify = JSON.stringify({ ...user});
          sessionStorage.setItem('user', userStringify);
          this.currentUser$$.next(user);
        })
      );
  }


  changeLogin(loginRequest: ChangeLoginRequest) {
    return this.httpClient
      .put<LoginResponse[]>(
        `${this.BASE_URL}${this.CONTEXT}/${this.CHANGE_LOGIN}`,
        loginRequest
      )
      .pipe(
        tap(([user]) => {
          this.tokenInject.setJwtToken(user.token);
          const userStringify = JSON.stringify({ ...user});
          sessionStorage.setItem('user', userStringify);
          this.currentUser$$.next(user);
        })
      );
  }

  resetBar() {
    this.selectClientService.resetClient();
    this.selectClientService.hasClient$$.next(false);
  }

  logoff() {
    sessionStorage.clear();
    this.resetBar();
    this.currentUser$$.next(null);
    this.cookies.deleteCookie('password');
  }

  getUser(seq_cliente: number = 10, index: number, length: number) {
    return this.httpClient.get<PaginatorResponse<UserResponse[]>>(
      `${this.BASE_URL}${this.CONTEXT}?seq_cliente=${seq_cliente}&index=${index}&length=${length}`
    );
  }
}
